export default {
  getOrderList: '/income/client/card/hitOrderList',
  getDetail: '/income/client/card/detail'
}
